import React, { useState } from "react";
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent";
import LoanDetailsModal from "./LoanDetailsModal/LoanDetailsModal";
import { Button } from "reactstrap";
import styles from "./ManageLoans.module.scss";

const ManageLoans = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const manageLoans = [
    { id: "#1234567", loanAmount: "$50,000", loanType: "Short-term Loan", repaymentOption: "Automatic Deduction", nextPaymentDue: '-', status: 'Pending' },
    { id: "#1234567", loanAmount: "$30,000", loanType: "Working Capital Loan", repaymentOption: "Manual Payment", nextPaymentDue: '20/07/2024', status: 'Active' },
    { id: "#1234567", loanAmount: "$50,000", loanType: "Short-term Loan", repaymentOption: "Flexible Payments", nextPaymentDue: '20/07/2024', status: 'Approved' },
    { id: "#1234567", loanAmount: "$100,000", loanType: "Long-term Loan", repaymentOption: "Automatic Deduction", nextPaymentDue: '20/07/2024', status: 'Pending' },
    { id: "#1234567", loanAmount: "$50,000", loanType: "Short-term Loan", repaymentOption: "Flexible Payments", nextPaymentDue: '20/07/2024', status: 'Disbursed' },
  ];

  const columns = [
    { name: "Loan ID", selector: (row) => row.id, minWidth: "120px" },
    { name: "Loan Type", selector: (row) => row.loanType, minWidth: "140px" },
    { name: "Loan Amount", selector: (row) => row.loanAmount, minWidth: "140px" },
    { name: "Repayment Option", selector: (row) => row.repaymentOption, minWidth: "180px" },
    { name: "Next Payment Due", selector: (row) => row.nextPaymentDue, minWidth: "180px" },
    { name: "Status", selector: (row) => row.status },
    {
      name: "Action",
      cell: () => (
        <div className={styles.actionButtonsContainer}>
          <Button
            color="link"
            className={styles.button}
            onClick={() => setIsModalOpen(!isModalOpen)}
          >
            View
          </Button>
          <Button
            color="link"
            className={styles.button}
          >
            Edit
          </Button>
        </div>
      ),
      minWidth: "140px"
    },
  ];

  return (
    <div className={styles.mainManageLoansContainer}>
      <h5 className={styles.sectionHeading}>Manage Loans</h5>
      <div className={styles.datatableContainer}>
        <DatatableComponent
          data={manageLoans}
          columns={columns}
          type={"yellow-bordered"}
        />
      </div>

      <LoanDetailsModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </div>
  );
};

export default ManageLoans;